import { PhoneOutgoing } from 'lucide-react';

import { Badge } from '@/components/ui/badge';

import { useCallDetail } from '@/context/CallProvider';

import { getOutcomeColorClass } from '@/lib/avatarColor';
import { humanizeDuration } from '@/lib/date';

export const CallDetails = () => {
  const { call: callDetail } = useCallDetail();

  return (
    <div className="relative flex-1 min-h-0">
      {/* bottom fade similar to transcript */}
      <div className="absolute left-0 right-0 bottom-0 h-8 pointer-events-none bg-gradient-to-b from-transparent to-white dark:to-zinc-900 z-10" />
      <div className="flex-1 h-full min-h-0 overflow-y-auto px-1 pr-3 pb-16 space-y-4 pt-1">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
          <div>
            <div className="text-xs text-muted-foreground">Phone number</div>
            <div className="flex items-center gap-1.5 mt-0.5">{callDetail.targetPhoneNumber}</div>
          </div>
          {/* Assistant details removed */}
          <div>
            <div className="text-xs text-muted-foreground">Date/time</div>
            <div className="flex items-center gap-1.5 mt-0.5">
              {new Date(callDetail.createdAt).toLocaleString()}
            </div>
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Call type</div>
            <div className="flex items-center gap-2 mt-0.5">
              <Badge variant="outline" className="inline-flex items-center gap-2">
                <PhoneOutgoing className="h-4 w-4 text-blue-700 dark:text-blue-400" />
                Outbound
              </Badge>
            </div>
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Outcome</div>
            <div className="flex items-center gap-2 mt-0.5">
              <Badge variant="outline">
                <svg
                  viewBox="0 0 6 6"
                  aria-hidden={true}
                  className={`!w-1.5 !h-1.5 ${getOutcomeColorClass(callDetail.callStatus)}`}
                >
                  <circle r="3" cx="3" cy="3" fill="currentColor" />
                </svg>
                <span className={getOutcomeColorClass(callDetail.callStatus)}>
                  {callDetail.callStatus}
                </span>
              </Badge>
            </div>
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Duration</div>
            <div className="flex items-center gap-1.5 mt-0.5">
              {humanizeDuration(callDetail.callDuration)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
